import { useEffect, useState } from "react";
import { SELECT_PRODUCTS_BASED_ON_ALL } from "../../../../../../../../../constants/selectProductsBasedOn.js";
import { useAppMutation } from "../../../../../../../../hooks/useAppMutation.js";
import CurrentSelectedProductsCard from "../../../CurrentSelectedProductsCard/CurrentSelectedProductsCard.js";


const AllProductsSection = ({ values, currentActionId, setIsProductUsed }) => {
    const [productsCount, setProductsCount] = useState(0);
    const [previewProducts, setPreviewProducts] = useState([]);

    const { mutate: mutateGetCountProducts, isLoading: isLoadingGetCountProducts } = useAppMutation({
        url: "/api/products/count",
        reactMutationOptions: {
            onSuccess(data) {
                setProductsCount(() => data.productsCount);
            }
        }
    });

    const { mutate: mutateGetPreviewProducts } = useAppMutation({
        url: "/api/products/all",
        reactMutationOptions: {
            onSuccess(data) {
                setPreviewProducts(data.products);
                setIsProductUsed(data.hasActionId)
            }
        }
    });

    useEffect(() => {
        setPreviewProducts(() => []);
        setProductsCount(0);

        mutateGetPreviewProducts({
            size: 3,
            page: 1,
            actionId: currentActionId || null
        })
        mutateGetCountProducts({})

    }, [values.tagsSelectionLogic, values.selectedTags]);

    return (
        <>
            <CurrentSelectedProductsCard
                selectedFilterOption={SELECT_PRODUCTS_BASED_ON_ALL}
                previewProducts={previewProducts}
                productsCount={productsCount}
                isLoading={isLoadingGetCountProducts}
                exceptionList={values.exceptionList} />
        </>
    );
}

export default AllProductsSection
